import { Link, Toolbar, Typography} from "@mui/material";
import colorConfigs from "../../configs/ColorConfigs";
import React from "react";

const Copyright = () => {
    return (
        <Toolbar position="fixed"
                 sx={{
                     color: colorConfigs.copyrightBar.color,
                 }}>
            <Typography variant="caption">
                <div>
                    {'Copyright © '}
                    <Link color="inherit" href="https://www.ultraceuticals.in/">Ultraceuticals.in</Link>{' '}
                    {new Date().getFullYear()}
                    {'.'}
                </div>
            </Typography>
        </Toolbar>
    );
};

export default Copyright;